import { routeAwards } from "./award-model.js";
/**
 * The current route from the workspace, then every other route from the award
 * collection. The workspace already drives the rest of the challenge screens,
 * so the current route renders even before, or without, the wider collection.
 */
export function routeAwardSections(workspace, collection) {
    const current = workspace.route
        ? [
            section(workspace.route, routeAwards(workspace.route, workspace.enrollment, workspace.milestoneHistory), true),
        ]
        : [];
    // The current route is the workspace's to show. Excluding it by the
    // collection's own id too keeps other routes correct when the workspace
    // has failed and has no route to compare against.
    const others = (collection?.routes ?? [])
        .filter((entry) => entry.route.instanceId !== workspace.route?.instanceId &&
        entry.route.instanceId !== collection?.currentInstanceId)
        .map((entry) => section(entry.route, routeAwards(entry.route, entry.enrollment, entry.milestoneHistory, {
        joinable: entry.route.instanceId === collection?.currentInstanceId,
    }), false));
    return [...current, ...others];
}
function section(route, awards, current) {
    return {
        instanceId: route.instanceId,
        name: route.name,
        imageUrl: route.imageUrl,
        imageAlt: route.imageAlt,
        current,
        awards,
        reached: awards.filter((award) => award.status === "reached").length,
    };
}
//# sourceMappingURL=route-award-sections.js.map